export default __webpack_public_path__ + "static/media/sliderImage-1.912949b2.jpg";